import { useModal } from '@ebay/nice-modal-react'
import {
  useRef,
  useState,
  type CSSProperties,
  type PropsWithChildren,
} from 'react'
import Draggable, { type DraggableEvent } from 'react-draggable'
import { styled } from '@linaria/react'

import { useBoundStore } from '../../store/store'

import {
  Copyrights,
  CustomerServiceButton,
  FooterLinks,
  GoUp,
  Header,
  InboxButton,
  PwaDownloadStepsModal,
  Sponsors,
} from '../common'
import { LinariaClassName } from '@linaria/core'

const FloatingButtons = styled.div`
  position: fixed;
  z-index: 15;
  bottom: 70px;
  right: 10px;
`

const DragBoundary = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: -10;
  opacity: 0;
  pointer-events: none;
  width: 100vw;
  height: 100vh;
`

const Footer = styled.div`
  padding-top: 50px;
  position: relative;
  background-color: #002335;
`

interface MobileLayoutProps {
  hideScrollUp?: boolean
  hideChat?: boolean
  hideInbox?: boolean
  bodyStyle?: CSSProperties
  hideBalance?: boolean
  className?: LinariaClassName
}

const MobileLayout = ({
  children,
  hideInbox,
  hideScrollUp,
  hideChat,
  bodyStyle,
  hideBalance,
  className,
}: PropsWithChildren<MobileLayoutProps>) => {
  const setIsDownloadPwaVisible = useBoundStore(
    state => state.common.setIsDownloadPwaVisible,
  )
  const isFullScreen = useBoundStore(state => state.common.isFullScreen)
  const pwaDownloadStepsModal = useModal(PwaDownloadStepsModal)
  const nodeRef = useRef(null)
  const [position, setPosition] = useState({ clientX: 0, clientY: 0 })
  const [timeStamp, setTimeStamp] = useState(0)

  const onStop = (e: DraggableEvent) => {
    const { changedTouches } = e as TouchEvent
    const dragTime = e.timeStamp - timeStamp
    if (
      (changedTouches[0].clientX === position.clientX &&
        changedTouches[0].clientY === position.clientY) ||
      dragTime < 200
    ) {
      const { id } = e.target as HTMLDivElement
      if (id === 'float-message-button') {
        window.open('https://t.me/fun88mxchannel', '_blank')
      } else if (id === 'float-customer-service') {
        window.fcWidget?.open()
      } else if (id === 'go-up') {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth',
        })
      } else if (id === 'pwa-icon') {
        pwaDownloadStepsModal.show()
      } else if (id === 'pwa-icon-close') {
        setIsDownloadPwaVisible(false)
      }
    }
  }

  const onStart = (e: DraggableEvent) => {
    const { changedTouches, timeStamp } = e as TouchEvent
    setPosition({
      clientX: changedTouches[0].clientX,
      clientY: changedTouches[0].clientY,
    })
    setTimeStamp(timeStamp)
  }

  return (
    <div className={className} style={bodyStyle}>
      <DragBoundary id="drag-boundary" />
      <Header hideBalance={hideBalance} />
      <Draggable
        onStart={onStart}
        onStop={onStop}
        axis="y"
        bounds="#drag-boundary"
        nodeRef={nodeRef}>
        <FloatingButtons ref={nodeRef} className="v-flx-ctr">
          {!hideScrollUp && <GoUp />}
          {!hideInbox && <InboxButton />}
          {!hideChat && <CustomerServiceButton />}
        </FloatingButtons>
      </Draggable>
      <div style={{ paddingTop: isFullScreen ? 0 : 60 }}>{children}</div>
      <Footer>
        <FooterLinks />
        <Sponsors />
        <Copyrights />
      </Footer>
    </div>
  )
}

export default MobileLayout
